import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-pods-status',
    templateUrl: './pods-status.component.html',
    styleUrls: ['./pods-status.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PodsStatusComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
